<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <div class="row">
                <div class="col-md-6"><i class="fa fa-book"></i> Employee Vaccination Declaration</div>
                <div class=" col-md-6 top-corner-items m-b-10">
                    <button class="btn btn-primary btn-sm m-r-5" (click)="vaccinationReport()"><i class="fa fa-download"></i> Vaccination Report</button>
                    <button class="btn btn-warning btn-sm m-r-5" (click)="openModal('#upload_vacc_data')"> <i class="fa fa-upload" aria-hidden="true"></i> Upload Vaccination Data</button>
                    <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard/covid19']"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>
            <div class="row m-t-30">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Employee Name</label>
                        <input class="form-control" [(ngModel)]="empName" type="text" readonly>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Employee ID</label>
                        <input class="form-control" type="text" [(ngModel)]="empID" readonly>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Vaccinated From</label>
                        <select class="form-control" (change)="vaccineFromChange($event)" [(ngModel)]="vaccineFrom">
                  <option value="">Select</option>
                  <option value={{data.value}} *ngFor="let data of dropDown">{{data.label}}</option>
                  </select>
                    </div>
                </div>
                <div class="col-md-3" *ngIf="isOther">
                    <div class="form-group">
                        <label>Reason</label>
                        <textarea class="form-control" placeholder="Reason..." [(ngModel)]="otherReason"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <!-- <span *ngFor="let data of declaredropDown; let i = index">
                  <input type="radio" id={{data.label}} name="rsn" value={{data.value}} [(ngModel)]="declare" class="m-r-5">
                  <label for={{data.label}}>{{data.label}}</label><br>  
                  </span> -->
                    <label><b>Vaccination Status</b></label> <br>
                    <input type="radio" id="rfused" name="rsn" disabled={{vaccStatus}} value="R" class="m-r-5" [(ngModel)]="vaccination" (change)="vaccinationChange()">
                    <label for="rfused">Refused</label><br>
                    <input type="radio" id="hld" name="rsn" value="Hold" class="m-r-5" [(ngModel)]="vaccination" (change)="vaccinationChange()">
                    <label for="hld">Hold(Recently got covid)</label><br>
                    <input type="radio" id="notapplicable" name="rsn" disabled={{vaccStatus}} value="N" class="m-r-5" [(ngModel)]="vaccination" (change)="vaccinationChange()">
                    <label for="notapplicable">Not Applicable</label>
                </div>
            </div>
            <div class="row m-t-30">
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-sm ">
                            <thead>
                                <tr class="bg-primary text-white">
                                    <th>Sr No.</th>
                                    <th>Employee Self Declaration Form</th>
                                    <th>Completed</th>
                                    <th>Pending</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of formQus; let i = index">
                                    <td>{{i+1}}</td>
                                    <td>{{data.name}}</td>
                                    <td><input type="radio" name={{data.radio}} disabled={{data.isDisabled}} value="Y" [(ngModel)]="data.status" (change)="changeDose(i)"></td>
                                    <td><input type="radio" name={{data.radio}} disabled={{data.isDisabled}} value="N" [(ngModel)]="data.status" (change)="changeDose(i)"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <section class="row d-flex justify-content-center pt-10">
                <button type="submit" class="btn btn-primary btn-sm m-r-5" (click)="submitSelfCovid()">Submit</button>
            </section>
        </div>
    </div>
</div>
<div id="upload_vacc_data" class="modal  custom-modal fade" data-backdrop="static" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_country_form_title"> Upload Vaccination Data</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()"><span aria-hidden="true">&times;</span></button>
            </div>
            <form [formGroup]="vaccineForm" (ngSubmit)="submitVaccineData()">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Select Cost Center<span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="cc_id">
                        <option value="">Select</option>
                        <option value={{data.value}} *ngFor="let data of roleWiseCostCenter">{{data.label}}</option>
                     </select>
                                <div *ngIf="submit && vaccineError.cc_id.errors" class="form-error">
                                    <div *ngIf="vaccineError.cc_id.errors.required">Cost Center is required !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Vaccinated From<span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="vacc_from">
                        <option value="">Select</option>
                        <option value={{data.value}} *ngFor="let data of dropDown">{{data.label}}</option>
                     </select>
                                <div *ngIf="submit && vaccineError.vacc_from.errors" class="form-error">
                                    <div *ngIf="vaccineError.vacc_from.errors.required">Please Choose an option !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Upload Vaccination Data <span class="text-danger">*</span></label><a href="{{httpBasePath.basePath$}}/uploads/download_format/vacc_format.xlsx" style="color: black;"><button type="button" class="btn btn-warning btn-sm m-l-5" > Download Format</button></a>
                                <input class="form-control" type="file" formControlName="vacc_data" (input)="onUploadVaccineData($event)">
                                <p class="text-danger">Please upload only .xlsx file</p>
                                <div *ngIf="submit && vaccineError.vacc_data.errors" class="form-error">
                                    <div *ngIf="vaccineError.vacc_data.errors.required">Attachment is required !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="m-t-30">
                        I have taken below mentioned undertaking from the employee while getting employee vaccinated .
                    </div>
                    <br>
                    <div>
                        <a href="{{httpBasePath.basePath$}}/uploads/download_format/EmployeeConsentFormVaccination%20.pdf" style="color: black;" target="_blank"> <button type="button" class="btn btn-warning btn-sm m-r-5">Download Document</button></a> <br>
                        <p> I ____________ age ___________, with Aadhar card number (alternate identification) _____________ working at _______________ site (client site name) am agreeing for taking the vaccine at _____ (client site name) under my own free
                            will and choice.</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary btn-sm "><i class="fa fa-save"></i> Agree & Submit</button>
                </div>
            </form>
        </div>
    </div>
</div>